// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Home Button

fullscreenButton = {};

fullscreenButton.create = function () {
  var button = new PIXI.Container();

  button._canShow = false;
  button._sideMenuOpen = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return button._sideMenuOpen;
  };

  button.canShow = function () {
    return button._canShow;
  };

  button.onPressedCallback = function () {
    if (Reflex.getIsFullScreen()) {
      gdk.exitFullscreen();
    } else {
      gdk.requestFullscreen();
    }
    if (button.soundName !== "") button.playSound();
  };

  button.onConfig = function (config) {
    button._canShow = config.data.uiElements.btnFullscreen.visible;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  messageBus.subscribe(
    "game:sideMenuOpen",
    button.sideMenuOpenMsg.bind(button)
  );
  messageBus.subscribe(
    "game:sideMenuClosed",
    button.sideMenuClosedMsg.bind(button)
  );
  messageBus.subscribe("spinner:GameConfigEvent", button.onConfig);

  return button;
};

fullscreenButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};

fullscreenButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "fullscreenButton",
  fullscreenButton.create,
  fullscreenButton.initialise,
  fullscreenButton.getFilesRequired
);
